/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealEstateDto } from './RealEstateDto';
import {
    RealEstateDtoFromJSON,
    RealEstateDtoFromJSONTyped,
    RealEstateDtoToJSON,
    RealEstateDtoToJSONTyped,
} from './RealEstateDto';
import type { QuestionAnswerDto } from './QuestionAnswerDto';
import {
    QuestionAnswerDtoFromJSON,
    QuestionAnswerDtoFromJSONTyped,
    QuestionAnswerDtoToJSON,
    QuestionAnswerDtoToJSONTyped,
} from './QuestionAnswerDto';

/**
 * 
 * @export
 * @interface GetRealEstateResponseDto
 */
export interface GetRealEstateResponseDto {
    /**
     * 
     * @type {RealEstateDto}
     * @memberof GetRealEstateResponseDto
     */
    realEstate: RealEstateDto;
    /**
     * List of questionnaire responses associated with the property
     * @type {Array<QuestionAnswerDto>}
     * @memberof GetRealEstateResponseDto
     */
    surveyAnswers?: Array<QuestionAnswerDto> | null;
}

/**
 * Check if a given object implements the GetRealEstateResponseDto interface.
 */
export function instanceOfGetRealEstateResponseDto(value: object): value is GetRealEstateResponseDto {
    if (!('realEstate' in value) || value['realEstate'] === undefined) return false;
    return true;
}

export function GetRealEstateResponseDtoFromJSON(json: any): GetRealEstateResponseDto {
    return GetRealEstateResponseDtoFromJSONTyped(json, false);
}

export function GetRealEstateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRealEstateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'realEstate': RealEstateDtoFromJSON(json['realEstate']),
        'surveyAnswers': json['surveyAnswers'] == null ? undefined : ((json['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoFromJSON)),
    };
}

export function GetRealEstateResponseDtoToJSON(json: any): GetRealEstateResponseDto {
    return GetRealEstateResponseDtoToJSONTyped(json, false);
}

export function GetRealEstateResponseDtoToJSONTyped(value?: GetRealEstateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realEstate': RealEstateDtoToJSON(value['realEstate']),
        'surveyAnswers': value['surveyAnswers'] == null ? undefined : ((value['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoToJSON)),
    };
}

